// TODO: ユーザストレージ、セッションストレージの共通処理はこのファイルに集約する
import { getUserStorage } from 'components/features/utils/utils';

// user
export const updateRegisteredWebPush = (isRegisteredWebPush: boolean): void => {
  const user = getUserStorage();
  if (user) {
    user.RegisteredWebPush = isRegisteredWebPush;
    sessionStorage.setItem('user', JSON.stringify(user));
  }
};

type ViewedWebPush = {
  dailyReport: boolean;
  securityAccounts: boolean;
};

// viewedWebPush
export const getViewedWebPushStorage = (): ViewedWebPush | null => {
  const userJson = sessionStorage.getItem('viewedWebPush');
  return userJson ? (JSON.parse(userJson) as ViewedWebPush) : null;
};

export const updateViewedWebPush = (
  dailyReport: boolean,
  securityAccounts: boolean
): void => {
  const storage = {
    dailyReport: dailyReport,
    securityAccounts: securityAccounts,
  };

  sessionStorage.setItem('viewedWebPush', JSON.stringify(storage));
};

export const updateViewedWebPushDailyReport = (dailyReport: boolean): void => {
  const viewedWebPush = getViewedWebPushStorage();

  if (viewedWebPush) {
    viewedWebPush.dailyReport = dailyReport;
    sessionStorage.setItem('viewedWebPush', JSON.stringify(viewedWebPush));
  }
};

export const updateViewedWebPushSecurityAccounts = (
  securityAccounts: boolean
): void => {
  const viewedWebPush = getViewedWebPushStorage();

  if (viewedWebPush) {
    viewedWebPush.securityAccounts = securityAccounts;
    sessionStorage.setItem('viewedWebPush', JSON.stringify(viewedWebPush));
  }
};
